import { render, staticRenderFns } from "./User_PAW_detail.vue?vue&type=template&id=601fb0b7&scoped=true&"
import script from "./User_PAW_detail.vue?vue&type=script&lang=js&"
export * from "./User_PAW_detail.vue?vue&type=script&lang=js&"
import style0 from "./User_PAW_detail.vue?vue&type=style&index=0&id=601fb0b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601fb0b7",
  null
  
)

export default component.exports